module.exports = __webpack_public_path__ + "static/best_req_mid-dd0c7354c8dbef7109d4e3b138d3e069.svg";